import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";

const quickLinks = [
  { label: "Servicios", href: "#servicios" },
  { label: "Proyectos", href: "#proyectos" },
  { label: "Contacto", href: "#contacto" },
  { label: "Blog", href: "/blog" },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#1A1A2E] text-white">
      {/* Top gradient line */}
      <div className="h-1 bg-gradient-to-r from-primary via-accent to-primary" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-5">
              <img
                src="/assets/logo.png"
                alt="Ms Vision Telecomunicaciones"
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="font-body text-white/55 text-sm leading-relaxed max-w-xs mb-6">
              Especialistas en infraestructura de redes HFC, GPON y fibra óptica en el AMBA. Conectamos hogares y empresas con tecnología de vanguardia.
            </p>
            {/* Social */}
            <div className="flex gap-3">
              {[
                { icon: Facebook, href: "https://facebook.com" },
                { icon: Instagram, href: "https://instagram.com" },
                { icon: Linkedin, href: "https://linkedin.com" },
              ].map(({ icon: Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${i}`}
                  className="w-9 h-9 bg-white/5 hover:bg-accent border border-white/10 hover:border-accent rounded-lg flex items-center justify-center transition-all duration-300"
                >
                  <Icon size={16} className="text-white/70 hover:text-white" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-heading font-bold text-white text-base mb-5 uppercase tracking-widest text-sm">
              Links Rápidos
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                    className="font-body text-white/55 hover:text-accent text-sm transition-colors duration-200 flex items-center gap-2 group"
                  >
                    <span className="w-1.5 h-1.5 bg-accent/50 rounded-full group-hover:bg-accent transition-colors duration-200" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-white text-base mb-5 uppercase tracking-widest text-sm">
              Contacto
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-accent flex-shrink-0 mt-0.5" />
                <span className="font-body text-white/55 text-sm leading-relaxed">
                  Laprida 4506 - Caseros, Buenos Aires, Argentina
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-accent flex-shrink-0" />
                <span className="font-body text-white/55 text-sm">0800 122 0402</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-accent flex-shrink-0" />
                <span className="font-body text-white/55 text-sm">info@msvision.com.ar</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-white/40 text-sm text-center md:text-left">
            &copy; {new Date().getFullYear()} Ms Vision Telecomunicaciones. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
            <span className="font-body text-white/40 text-xs">Sistemas operativos</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
